

mainApp.component('dhcpRelayGroups', {
	templateUrl: '/public/components/dhcp-relay-groups.component.html',
	bindings: {
		model: '<',
		errors: "<",
		changeListener: '&'
	},
	controller: dhcpRelayGroupController
});


function dhcpRelayGroupController(GeneralUtilsService, $scope) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.original = angular.copy(ctrl.model);
		ctrl.hasChanges = false;
		ctrl.tableDataModified = false;
	}

	ctrl.$doCheck = () => {
		if (!ctrl.changeListener)
			return;

		let isChangedNow = !angular.equals(ctrl.model, ctrl.original);

		// we only care when state is changed...
		if (ctrl.hasChanges === isChangedNow)
			return;

		ctrl.hasChanges = isChangedNow;
		ctrl.changeListener({isDirty: ctrl.hasChanges, componentName: 'dhcpRelayGroups'});
	}

	$scope.$on('modelReloadedEvent', function (event, data) {
		ctrl.original = angular.copy(ctrl.model);
		ctrl.tableDataModified = new Date().getTime();
	});

	ctrl.reset = () => {
		ctrl.original = angular.copy(ctrl.model);
		ctrl.hasChanges = false;
		ctrl.tableDataModified = new Date().getTime();
	}

	ctrl.dhcpRelayGroupConfig = {
		id: 'dhcpRelayGroups',
		dataURL: () => {
			return null;
		},
		parseData: () => {
			return ctrl.model;
		},
		fields: [
			{
				label: 'Group Name',
			  	path: 'name',
			  	template: "<span><input type='text' class='form-control' ng-model='item.name' placeholder='e.g. DHCP-Group-1'/></span>",
			  	noSort: true
			},
			{
				label: 'DHCP Relay Servers',
				path: 'ips',
				template: "<span><input type='text' class='form-control' ng-model='item.ips' placeholder='e.g. 10.0.0.1,10.0.0.2,10.0.0.3'/></span>",
				noSort: true
			},
		],
		actions: [],
		addAction:  () => {
			let isAccountSelectedGroup = ctrl.model.length === 0;
			ctrl.model.push({ id: GeneralUtilsService.getRandomId(), name: '', ips: '', accountSelectedGroup: isAccountSelectedGroup});
			ctrl.tableDataModified = new Date().getTime();
		},
		specialActions: [
			{ func: (selectedItems) => {
					selectedItems.forEach((item) => {
						_.remove(ctrl.model, dhcpRelayGroup => dhcpRelayGroup.id === item.id);
					});
				},
				icon: 'delete',
				tooltip: 'Delete' },
		],
		selectedItems: [],
		noSearch: true,
	};
};

